import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { checkAdminSession } from "@/services/session";

const AdminLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    (async () => {
      const ok = await checkAdminSession();
      if (!alive) return;
      if (ok) navigate("/recruit-admin/dashboard", { replace: true });
      else navigate("/", { replace: true });
    })();
    return () => {
      alive = false;
    };
  }, [navigate]);

  return <div className="p-6 text-center">Redirecting…</div>;
};

export default AdminLogin;
